/**
 * Created with Mei Zhiwei on 2018-07-19 15:49:46.
 * Description: 接入类型
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: meizhiwei@meituan.com
 * @Last Modified time: 2018-07-20 14:34:52
 */
export const barCodeTypes = {
  0: '美团取餐号',
  1: '厂商取餐号'
};



// WEBPACK FOOTER //
// ./src/config/barCodeTypes.js